export default {
    topics: [
        {
            title: ' sleep ',
            href: 'f-sleep.html',
            attributes: { 'data-id': 'f-sleep' },
            menu: { hasChildren: false },
            tocID: 'f-sleep-d66e4810',
            topics: [],
        },
        {
            title: ' getEnv ',
            href: 'f-getEnv.html',
            attributes: { 'data-id': 'f-getEnv' },
            menu: { hasChildren: false },
            tocID: 'f-getEnv-d66e4818',
            topics: [],
        },
        {
            title: ' setEnv ',
            href: 'f-setEnv.html',
            attributes: { 'data-id': 'f-getEnv' },
            menu: { hasChildren: false },
            tocID: 'f-getEnv-d66e4826',
            topics: [],
        },
        {
            title: ' execCommand ',
            href: 'f-execCommand.html',
            attributes: { 'data-id': 'f-execCommand' },
            menu: { hasChildren: false },
            tocID: 'f-execCommand-d66e4834',
            topics: [],
        },
    ],
};

